import { hasPendingStripeRequirements } from './stripeRequirements';

export const isDefaultIban = (iban) => {
    if (!iban) return true;
    const normalizedIban = iban.replace(/[\s-]/g, '').toUpperCase();
    return normalizedIban === '' || /^(ES|AD)[X0]{22}$/.test(normalizedIban);
};

export const getTreasuryWarnings = ({ paymentInfo, stripeConnectStatus, legalBoardBadge, publicUtilityBadge } = {}) => {
    const warnings = [];
    if (paymentInfo && (isDefaultIban(paymentInfo.iban) || !paymentInfo.legalName || !paymentInfo.nif)) {
        warnings.push('Dades fiscals');
    }
    if (legalBoardBadge?.level) {
        warnings.push('Registre');
    }
    if (publicUtilityBadge?.level) {
        warnings.push('Utilitat pública');
    }
    if (stripeConnectStatus && (!stripeConnectStatus.verified || hasPendingStripeRequirements(stripeConnectStatus.requirements))) {
        warnings.push('Pagaments');
    }
    return warnings;
};
